import TablaYounet from '../Elementos/TablaYounet';


const Element =()=>{

    const headCellsColumn = [
        { id: 'Nombre', numeric: true, disablePadding: false, label: 'Nombre', show:true, fixed:false, width:250, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Direccion', numeric: false, disablePadding: false, label: 'Direccion', show:true, fixed:false, width:350, num:1, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Correo', numeric: false, disablePadding: false, label: 'Correo', show:true, fixed:false, width:300, num:2, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Celular', numeric: false, disablePadding: false, label: 'Celular', show:true, fixed:false, width:200, num:3, align:'left', fontSize:'16px', bolder:false , type:'text'    },
    ];

    const variablesObject = {
        api:'/api/Proveedores',
        apiMultiples:'/api/Proveedores/multiple',
        isButtonAdd:true,
        isMultiline:false,
        isUpperCase:false,   
        label:'PROVEEDOR',
        nameLocalStorage:'headersProveedorAC',
        order:'asc',
        orderBy:'Nombre',
        OptionSearch:'Nombre',
        rowsPerPage:15,
        Ruta:'/Almacen/Proveedor',
        sumWidth:1260,
        title:'PROVEEDORES',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
        widthAction:160,
    };

    return (
        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
        />
    )
}

export default Element;